import { FormlyFieldConfig } from '@ngx-formly/core';
import { OPTIONS_EDITOR_FIELDARRAY } from '../../core/config/field-configs/field-config-shared';

/**
 * Returns the Formly field definitions for the lookup list create/edit form.
 *
 * Accepted a `translate` function so labels are resolved at runtime via
 * TranslationService rather than being baked in as static keys.
 *
 * Fields:
 *  - name        (text, required)
 *  - is_active   (radio: Active / Inactive)
 *  - options     (options-editor — reuses the shared fieldArray config)
 *
 * The model should also include `optionsSource: 'lookup-list'` so that the
 * options-editor component suppresses its "Promote to Lookup List" button.
 */
export function getLookupListEditFields(translate: (key: string) => string): FormlyFieldConfig[] {
  return [
    {
      key: 'name',
      type: 'text',
      wrappers: ['inline-edit'],
      props: {
        label: translate('lookupList.name.label'),
        placeholder: translate('lookupList.name.placeholder'),
        required: true,
        inlineEditVariant: 'title',
      },
    },
    {
      key: 'is_active',
      type: 'radio',
      props: {
        label: translate('lookupList.status.label'),
        options: [
          { value: true, label: translate('lookupList.status.active') },
          { value: false, label: translate('lookupList.status.inactive') },
        ],
      },
    },
    {
      key: 'options',
      type: 'options-editor',
      className: 'flex-basis-full',
      // Reuses the shared fieldArray so any future column changes apply everywhere.
      fieldArray: OPTIONS_EDITOR_FIELDARRAY,
    },
  ];
}
